// POST /api/plaid/link_token, per the M1 execution plan §5.1 (owner WS-B) and
// this plan's WS-3 hook list. Body `{item_id?: uuid|null}`: omitted/null mints
// a normal Link token, present mints an UPDATE-mode token for reconnect flows
// (needs-login / pending-expiration / error). The response never carries an
// access token -- only a short-lived link_token the browser hands to Plaid
// Link, which is the one token this seam is allowed to touch.
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import client from '../client';
import { parseEnvelope } from '../envelope';
const linkTokenBaseSchema = z.object({
  link_token: z.string(),
  expiration: z.string(),
  request_id: z.string(),
});

export const linkTokenResponseSchema = z.discriminatedUnion('mode', [
  linkTokenBaseSchema.extend({
    mode: z.literal('new'),
    reservation_id: z.string(),
  }),
  linkTokenBaseSchema.extend({
    mode: z.literal('update'),
    item_id: z.string(),
  }),
]);

export type LinkTokenResponse = z.infer<typeof linkTokenResponseSchema>;

/** `itemId` present -> update-mode token for an existing connection; omitted -> a fresh Link. */
export function usePlaidLinkToken() {
  return useMutation({
    mutationFn: async (itemId?: string | null): Promise<LinkTokenResponse> => {
      const response = await client.post('/api/plaid/link_token', { item_id: itemId ?? null });
      return parseEnvelope(linkTokenResponseSchema, response.data).data;
    },
  });
}
